export const UpdateHistoryExcelColumns = [
  {
    header: "RDD History",
    key: "RequestedDeliveryDate",
  },
  {
    header: "Requirement Category History",
    key: "RequirementCategory",
  },
  {
    header: "Airport Code History",
    key: "AirportCode",
  },
  {
    header: "Customer PO",
    key: "CustomerPo",
  },
  // {
  //   header: "Customer PO Line",
  //   key: "CustomerPoLine",
  // },
  // {
  //   header: "Attention Name History",
  //   key: "AttentionName",
  // },
  // {
  //   header: "Attention Phone History",
  //   key: "AttentionPhone",
  // },
  {
    header: "Shipping Address History",
    key: "ShippingAddress",
  },
  {
    header: "Company/Consignee Name History",
    key: "ConsigneeName",
  },
  {
    header: "Company/Consignee Address History",
    key: "ConsigneeAddress",
  },
  {
    header: "Defect Reason History",
    key: "defectReason",
  },
  // {
  //   header: "Release Type History",
  //   key: "ReleaseType",
  // },
  // {
  //   header: "E-Mail History",
  //   key: "Email",
  // },
  {
    header: "Remark of Customer",
    key: "customerRemark",
  },
  {
    header: "Created Date",
    key: "createdDate",
  },
  {
    header: "Created By",
    key: "createdBy",
  },
];

export const UpdateHistoryExcelName = "UpdateHistory";
